// extracted by mini-css-extract-plugin
export default {"misiItem":"VisiMisi_misiItem__WrcFH","misiDesc":"VisiMisi_misiDesc__EPJvP"};